'use client';

import styles from './EntityHeroWithBG.module.scss';

const EntityHeroVideo = ({ url, ext }: { url: string; ext: string; }) => (
  <div className={styles.headerSection__videoWrapper}>
    <video
      autoPlay
      loop
      muted
      playsInline
      className={styles.headerSection__video}
      onClick={(e) => e.preventDefault()}
    >
      <source
        src={url}
        type={`video/${ext}`}
      />
    </video>
    <div className={styles.headerSection__videoWrapperOverlay} />
  </div>
);

export default EntityHeroVideo;
